import * as React from 'react';
import { IntlProvider } from 'react-intl';
import { ToastContainer } from 'react-toastify';

import ptBR from 'antd/locale/pt_BR';

import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import Alert from 'components/Alert';

import { ThemeProvider } from '@eduzz/ui-antd-theme';

const intlFormats = {
  number: {
    BRL: {
      style: 'currency' as const,
      currency: 'BRL'
    },
    USD: {
      style: 'currency' as const,
      currency: 'USD'
    }
  }
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});

type AppProvidersProps = {
  children: React.ReactNode;
};

function AppProviders({ children }: AppProvidersProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <IntlProvider locale='pt-BR' formats={intlFormats} defaultFormats={intlFormats}>
        <ThemeProvider locale={ptBR}>
          <Alert.Global />
          {children}
          <ToastContainer theme='colored' style={{ width: 'auto' }} />
          <ReactQueryDevtools buttonPosition='bottom-right' />
        </ThemeProvider>
      </IntlProvider>
    </QueryClientProvider>
  );
}

export { AppProviders };
